import {useEffect, useState} from "react";

export const useClearCache =() => {
    const [state] = useState(localStorage.getItem('cacheClear'))
    useEffect(() => {
        if (!state) {
            localStorage.setItem('cacheClear', 'true');
            window.location.reload(true);
        }
    }, []);

    return [state]
}